<template>
    <FormsAutocomplete 
        v-model="model"  
        :item="collection"
        :label="label"
        :clearable="clearable"
        :disabled="disabled"
        :multiple="multiple"
        :error-messages="errorMessages"
        :dense="dense"
        :item-value="itemValue"
        :item-text="itemText"
        v-bind="$attrs"
    />
</template>

<script setup>

import { defineProps, defineEmits, ref, computed } from 'vue'

const emit = defineEmits(['input'])

const props = defineProps({
    label: { type: String, default: 'Horário*'},
    clearable: { type: Boolean, required: false },
    disabled: { type: Boolean, required: false },
    dense: { type: Boolean, required: false },
    multiple: { type: Boolean, required: false },
    value: { type: [String, Number, Array] },
    errorMessages: { type: Array, required: false },
    itemValue: { type: String, default: 'id'},
    itemText: { type: String, default: 'name'},
})

const model = computed({
  get: () => props.value,
  set: val => emit('input', val)
})

const collection = ref([
    { id: 1, name: 'Domingo',       initials: 'DOM'},
    { id: 2, name: 'Segunda-Feira', initials: 'SEG'},
    { id: 3, name: 'Terça-Feira',   initials: 'TER'},
    { id: 4, name: 'Quarta-Feira',  initials: 'QUA'},
    { id: 5, name: 'Quinta-Feira',  initials: 'QUI'},
    { id: 6, name: 'Sexta-Feira',   initials: 'SEX'},
    { id: 7, name: 'Sábado',        initials: 'SÁB'},
])
</script>
